export default __webpack_public_path__ + "static/media/video1-en.07832861.mp4";